<template>
    <div style="display: flex; flex-direction: column;">
        <main-swiper></main-swiper>
        <div class="marvelExhibition">
            <p class="marvelExhibition-tit" v-if="ailist.length>0">
                <img  @dragstart.prevent  src="../assets/icon_zhineng.png" class="icon" alt="" />
                智能AI
            </p>
            <div class="marvelExhibitionPic">
                <div class="marvelExhibitionPic-item" v-for="(item,index) in ailist" :key="'a'+index">
                    <img  @dragstart.prevent  :src="item" alt="">
                </div>
            </div>
            <p class="marvelExhibition-tit" v-if="useList.length>0 && actindex == 0">
                <img  @dragstart.prevent  src="../assets/icon_yonghutougao.png" class="icon" alt="" />
                用户投稿
            </p>
            <p class="marvelExhibition-tit" @click="actuser(0)" v-if="useList.length>0 && actindex != 0">
                <<返回
            </p>
            <div class="marvelExhibitionPic">
                <!-- <div class="marvelExhibitionPic-item" v-for="(item,index) in useList" :key="index"> -->
                     <div class="marvelExhibitionPic-item" style="display: flex;" v-if="actindex == 0">
                 <img  @dragstart.prevent @click="actuser(1)"  src="../assets/ju/01.png" alt="" style="margin-left: 10px;margin-right: 20px;">
                     <img  @dragstart.prevent @click="actuser(2)"  src="../assets/ju/02.png" alt="" style="margin-right: 20px;">
                      <img  @dragstart.prevent @click="actuser(3)" src="../assets/ju/03.png" alt="" style="margin-right: 20px;">
                       <img  @dragstart.prevent @click="actuser(4)" src="../assets/ju/04.png" alt="" style="margin-right: 20px;">
                    
                </div>
            </div>
            <div class="detaile_con">
                <div class="one_item"  v-if="actindex == 1">
                    <img src="../assets/ju/101.jpg" alt="">
                    <img src="../assets/ju/102.jpg" alt="">
                    <img src="../assets/ju/103.jpg" alt="">
                    <img src="../assets/ju/104.jpg" alt="">
                    <img src="../assets/ju/105.jpg" alt="">
                    <img src="../assets/ju/106.jpg" alt="">
                    <img src="../assets/ju/107.jpg" alt="">
                    <img src="../assets/ju/108.jpg" alt="">
                    <img src="../assets/ju/109.jpg" alt="">
                    <img src="../assets/ju/110.jpg" alt="">
                    <img src="../assets/ju/111.jpg" alt="">
                    <img src="../assets/ju/112.jpg" alt="">
                    <img src="../assets/ju/113.jpg" alt="">
                </div>
                <div class="one_item"  v-if="actindex == 2">
                    <img src="../assets/ju/201.jpg" alt="">
                    <img src="../assets/ju/202.jpg" alt="">
                    <img src="../assets/ju/203.jpg" alt="">
                    <img src="../assets/ju/204.jpg" alt="">
                    <img src="../assets/ju/205.jpg" alt="">
                    <img src="../assets/ju/206.jpg" alt="">
                    <img src="../assets/ju/207.jpg" alt="">
                    <img src="../assets/ju/208.jpg" alt="">
                    <img src="../assets/ju/209.jpg" alt="">
                    <img src="../assets/ju/210.jpg" alt="">
                    <img src="../assets/ju/211.jpg" alt="">
                    <img src="../assets/ju/212.jpg" alt="">
                    <img src="../assets/ju/213.jpg" alt="">
                </div>
                <div class="one_item"  v-if="actindex == 3">
                    <img src="../assets/ju/301.jpg" alt="">
                    <img src="../assets/ju/302.jpg" alt="">
                    <img src="../assets/ju/303.jpg" alt="">
                    <img src="../assets/ju/304.jpg" alt="">
                    <img src="../assets/ju/305.jpg" alt="">
                    <img src="../assets/ju/306.jpg" alt="">
                    <img src="../assets/ju/307.jpg" alt="">
                    <img src="../assets/ju/308.jpg" alt="">
                    <img src="../assets/ju/309.jpg" alt="">
                    <img src="../assets/ju/310.jpg" alt="">
                    <img src="../assets/ju/311.jpg" alt="">
                    <img src="../assets/ju/312.jpg" alt="">
                    <img src="../assets/ju/313.jpg" alt="">
                    <img src="../assets/ju/314.jpg" alt="">
                    <img src="../assets/ju/315.jpg" alt="">
                    <img src="../assets/ju/316.jpg" alt="">
                    <img src="../assets/ju/317.jpg" alt="">
                    <img src="../assets/ju/318.jpg" alt="">
                    <img src="../assets/ju/319.jpg" alt="">
                    <img src="../assets/ju/320.jpg" alt="">
                    <img src="../assets/ju/321.jpg" alt="">
                    <img src="../assets/ju/322.jpg" alt="">
                </div>
                <div class="one_item"  v-if="actindex == 4">
                    <img src="../assets/ju/401.jpg" alt="">
                    <img src="../assets/ju/402.jpg" alt="">
                    <img src="../assets/ju/403.jpg" alt="">
                    <img src="../assets/ju/404.jpg" alt="">
                    <img src="../assets/ju/405.jpg" alt="">
                    <img src="../assets/ju/406.jpg" alt="">
                    <img src="../assets/ju/407.jpg" alt="">
                    <img src="../assets/ju/408.jpg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import MainSwiper from '../components/mainSwiper.vue'
import {marvelAi, marvelContribute } from '@/utils/api'
import { onMounted ,ref} from 'vue'
let ailist = ref([])
let useList = ref([])
let actindex = ref(0)
const actuser = async(val)=>{
    actindex.value = val
}
onMounted(()=>{
    useList.value = ['../assets/ju/01.png','https://hnbkbw.cn/uploads/allimg/4/01.png','https://hnbkbw.cn/uploads/allimg/4/01.png','https://hnbkbw.cn/uploads/allimg/4/01.png',]
    return false
    marvelAi().then(res=>{
        ailist.value = res.data.imgs
    })
    marvelContribute().then(res=>{
        useList.value = res.data.imgs
    })
})
</script>

<style lang="scss" scoped>
.marvelExhibition{
    min-width: 1188px;
    margin: 0 auto;
    padding: 0px 0 80px;
    &-tit{
        display: flex;
        align-items: center;
        margin-top: 30px;
        .icon{
            width: 36px;
            height: 36px;
            margin-right: 16px;
        }
        span{
            font-size: 28px;
            color: #333333;
            line-height: 40px;
        }
    }
    .marvelExhibitionPic{
        width: 1188px;
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;

        &-item{
            width: 270px;
            height:270px;
            margin-top: 30px;
            margin-right: 20px;
            img{
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }
        }
    }
    .detaile_con{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        
    }
    .one_item{
        flex-direction: column;
        justify-content: center;
        width: 100%;
        align-items: center;
        }
}
</style>